module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-002.6fe2ce22.jpg";